<template>
  <div class="subscription-flow" v-if="!asyncLoading">
    <!--We use v-show and not v-if because the credit-card component cannot be re-rendered-->
    <!--The fields in it are mounted by payme making rerendering heavy and destroying previous context-->
    <template v-if="onCreditCardStep">
      <credit-card v-show="onCreditCardStep" :first-billing-date="firstBillingDate"/>
    </template>
    <template v-else>
      <done v-show="onDone" :first-billing-date="firstBillingDate"/>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import CreditCard from './pages/CreditCard.vue';
import Done from './pages/Done.vue';
import Segment from '../../../../Segment';

export default {
  name: 'SubscriptionFlow',
  components: {
    CreditCard,
    Done,
  },
  data() {
    return {
      asyncLoading: true,
    };
  },
  async created() {
    Segment.trackUserGot('SubscriptionEntered');
    await this.fetchFirstBillingDate();
    this.asyncLoading = false;
  },
  computed: {
    ...mapGetters('subscription', ['onCreditCardStep', 'onDone']),
    ...mapState('subscription', ['firstBillingDate']),
  },
  methods: {
    ...mapActions('subscription', ['fetchFirstBillingDate']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../scss/mixins';

  .subscription-flow {
  }
</style>
